export const reliability = [
  {
    title: "هماهنگ با زیرساخت فعلی",
    desc: "مرحله‌به‌مرحله و بدون پیچیدگی به سمت زیرساخت‌های ابری",
    logo: "virtualOrganization.svg",
    imgAlt: "هماهنگ با زیرساخت فعلی",
    imgTitle: "هماهنگ با زیرساخت فعلی",
  },
  {
    title: "دفاع چند لایه ابری",
    desc: "پیشرفته‌ترین سرویس‌های امنیتی برای خط مقدم سازمانی",
    logo: "startup.svg",
    imgAlt: "دفاع چند لایه ابری",
    imgTitle: "دفاع چند لایه ابری",
  },
  {
    title: "مطابق با الزامات امنیتی",
    desc: "تایید شده توسط نهادهای امنیتی از جمله پدافند غیرعامل",
    logo: "disaster.svg",
    imgAlt: "مطابق با الزامات امنیتی",
    imgTitle: "مطابق با الزامات امنیتی",
  },
  {
    title: "معماری‌های توزیع‌شده",
    desc: "پایدار، مطمئن و مقاوم در برابر خطا، حتی در شرایط بحرانی",
    logo: "test.svg",
    imgAlt: "معماری‌های توزیع‌شده",
    imgTitle: "معماری‌های توزیع‌شده",
  },
];

export const solutions = [
  {
    img: "1.svg",
    title: "مهاجرت ابری آبالون",
    desc: "با مهاجرت ابری به‌عنوان بخشی از راهکارهای تخصصی آبالون، سرویس‌های سازمانی به‌صورت مطمئن و مرحله‌به‌مرحله به ابر منتقل می‌شوند؛ بدون آنکه اختلالی در عملیات جاری ایجاد شود. آبالون با تکیه بر تجربه عملی و تیم متخصص، معماری ابری اختصاصی سازمان شما را طراحی کرده و سرویس‌ها را برای محیط ابری بهینه می‌کند تا مهاجرت تدریجی و ایمن امکان‌پذیر شود.",
    link: "/cloud-migration",
    linkText: "آشنایی با مهاجرت ابری آبالون",
    linkTitle: "مهاجرت ابری آبالون",
  },
  {
    img: "2.svg",
    title: "خدمات زیرساختی آبالون",
    desc: "با خدمات زیرساختی آبالون به‌عنوان بخشی از راهکارهای تخصصی آبالون، متناسب با نیاز سازمان شما، یک زیرساخت ابری سفارشی‌سازی‌شده فراهم می‌شود. این خدمات شامل  ابر خصوصی، ابر ایزوله برای اتصال ایمن به دیتاسنترهای آبالون و کوبرنتیز مدیریت‌شده برای اپلیکیشن‌های کانتینری است؛ تا از هر نقطه کشور، بستری امن و با بالاترین کارایی و پایداری را در اختیار داشته باشید.",
    link: "/infrastructure-services",
    linkText: "آشنایی با خدمات زیرساختی آبالون",
    linkTitle: "خدمات زیرساختی آبالون",
  },
  {
    img: "3.svg",
    title: "راهکارهای امنیتی آبالون",
    desc: "راهکارهای امنیتی آبالون به‌عنوان بخشی از راهکارهای تخصصی آبالون،  امنیت و پایداری داده‌ها و سامانه‌های سازمانی شما را در برابر تهدیدات پیچیده تضمین می‌کند. این راهکارها مجموعه‌ای از لایه‌های حفاظتی پیشرفته شامل سرویس‌های PAM ابری، WAF، محافظت در برابر حملات DDoS، راهکارSOC، سامانه SIEM و پلتفرم فضای کاری امن آبالون را در بر می‌گیرد و امکان پایش، تحلیل لحظه‌ای  شبکه و واکنش بلادرنگ به تهدیدات را به‌صورت یکپارچه فراهم می‌کند.",
    link: "/cloud-security",
    linkTitle: "آشنایی با راهکارهای امنیتی آبالون",
    linkText: "راهکارهای امنیتی آبالون",
  },
];

export const enterpriseServices = [
  {
    title: "سامانه‌های اختصاصی",
    cap: "طراحی مطابق نیازهای امنیتی، زیرساختی و ذخیره‌سازی",
  },
  {
    title: "لینک اختصاصی",
    cap: "اتصال پرسرعت، ایزوله از اینترنت و ویژه شبکه نورونتا",
  },
  {
    title: "پشتیبانی اختصاصی",
    cap: "پاسخ‌گویی شبانه‌روزی با تیم پشتیبانی فنی Proactive",
  },
  {
    title: "اکانت‌منیجر اختصاصی",
    cap: "نماینده ویژه شما برای پیگیری لحظه‌ای درخواست‌ها",
  },
];

export const popularServices = [
  {
    title: "محصولات آبالون",
    desc: "با استفاده از محصولات ابری و دیتاسنتری آبالون، زیرساخت امن، پایدار و مقیاس‌پذیر سازمان‌تان را بدون پیچیدگی‌های فنی ایجاد کنید.",
    logo: "VPS-Service.svg",
    route: "/products",
  },
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه SIEM از سرویس‌های سازمانی خود در فضای ابری محافظت کنید.",
    logo: "CloudGuard-Service.svg",
    route: "/cloud-security",
  },
  {
    title: "شبکه ابری آبالون",
    desc: "با شبکه ابری آبالون، ترافیک سازمان‌تان را بهینه مدیریت کنید، محدودیت‌های دسترسی را برطرف کنید و اتصال پایدار و امن را تجربه کنید.",
    logo: "VPC-Service.svg",
    route: "/network",
  },
  {
    title: "شبکه توزیع محتوای CDN آبالون",
    desc: "با بیش از ۴۰ پاپ‌سایت فعال در ایران و ۵ قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان خود را با کمترین تأخیر، سریع‌تر و ایمن‌تر به کاربران برسانید.",
    logo: "ManagedService-Service.svg",
    route: "/cdn",
  },
];

export const questions = [
  {
    title: "راهکارهای تخصصی آبالون چه تفاوتی با سرویس‌های عمومی ابری دارند؟",
    answer:
      "راهکارهای تخصصی آبالون متناسب با الزامات سازمانی طراحی می‌شوند و شامل مهاجرت، زیرساخت، امنیت و پشتیبانی اختصاصی هستند. برخلاف سرویس‌های عمومی، این خدمات به‌صورت سفارشی‌سازی‌شده و با در نظر گرفتن نیازهای خاص هر سازمان پیاده‌سازی می‌شوند.",
  },
  {
    title:
      "آیا استفاده از راهکارهای تخصصی آبالون نیاز به تغییر کامل زیرساخت فعلی سازمان دارد؟",
    answer:
      "خیر. این راهکارها قابلیت پیاده‌سازی مرحله‌ای و سازگار با زیرساخت موجود را دارند تا استقرار‌ سامانه‌های امنیتی و زیرساختی یا حتی مهاجرت یا توسعه به سمت ابر بدون وقفه در عملیات جاری انجام شود.",
  },
  {
    title: "چه سازمان‌هایی بیشترین بهره را از راهکارهای تخصصی آبالون می‌برند؟",
    answer:
      "سازمان‌هایی که به امنیت پیشرفته، مدیریت متمرکز، و دسترسی پایدار در مقیاس سازمانی نیاز دارند، بیشترین ارزش را از این راهکارها دریافت می‌کنند. این خدمات به‌ویژه برای بانک‌ها، موسسات مالی، شرکت‌های بزرگ و نهادهای دولتی که با داده‌های محرمانه سروکار دارند مناسب هستند.",
  },
  {
    title: "آیا راهکارهای تخصصی آبالون در بلندمدت قابل اعتماد هستند؟",
    answer:
      "بله، راهکارهای تخصصی آبالون با معماری پایدار و مقیاس‌پذیر طراحی شده‌اند تا همراه با رشد سازمان توسعه پیدا کنند. این راهکارها امکان گسترش منابع بدون محدودیت، ارتقا متناسب با نیازهای آینده و تضمین امنیت در تمام مراحل را فراهم می‌کنند.",
  },
];
